/* prettier-ignore */
export const GlobalMode1 = {
  'color-alpha-white-20': '#ffffff33',
  'color-brand-general-mills-generalMills-blue': '#1e265e',
  'color-brand-general-mills-generalMills-heart': '#e32726',
  'color-brand-general-mills-generalMills-red': '#db0038',
  'color-grayscale-black': '#000000',
  'color-grayscale-coolGray-100': '#e3e3e3',
  'color-grayscale-coolGray-200': '#929295',
  'color-grayscale-coolGray-300': '#78787f',
  'color-grayscale-coolGray-400': '#5f5f68',
  'color-grayscale-coolGray-500': '#484850',
  'color-grayscale-coolGray-600': '#333333',
  'color-grayscale-coolGray-700': '#292929',
  'color-grayscale-coolGray-800': '#212121',
  'color-grayscale-coolGray-900': '#0d0d0d',
  'color-grayscale-warmGray-100': '#f5f5f6',
  'color-grayscale-warmGray-200': '#eeeeee',
  'color-grayscale-warmGray-300': '#d8d8d8',
  'color-grayscale-warmGray-400': '#888888',
  'color-grayscale-warmGray-500': '#555555',
  'color-grayscale-warmGray-600': '#4d4d4d',
  'color-grayscale-warmGray-700': '#333333',
  'color-grayscale-warmGray-800': '#212121',
  'color-grayscale-warmGray-900': '#030303',
  'color-grayscale-white': '#ffffff',
  'color-system-effects-shadow': '#ffffff',
  'color-system-effects-shadow-2': '#ffffff',
  'color-system-error-100': '#ffd9d9',
  'color-system-error-500': '#b50000',
  'color-system-error-900': '#4b0000',
  'color-system-error-on-inverse-100': '#ffffff',
  'color-system-error-on-inverse-500': '#ffffff',
  'color-system-error-on-inverse-900': '#ffffff',
  'color-system-focus-100': '#c6e0fd',
  'color-system-focus-500': '#1979df',
  'color-system-focus-900': '#002043',
  'color-system-focus-on-inverse-100': '#ffffff',
  'color-system-focus-on-inverse-500': '#ffffff',
  'color-system-focus-on-inverse-900': '#ffffff',
  'color-system-social-media-facebook': '#1877f2',
  'color-system-social-media-pinterest': '#bb171f',
  'color-system-success-100': '#c0f1c6',
  'color-system-success-500': '#00a113',
  'color-system-success-900': '#004308',
  'color-system-success-on-inverse-100': '#ffffff',
  'color-system-success-on-inverse-500': '#ffffff',
  'color-system-success-on-inverse-900': '#ffffff',
  'color-system-warning-100': '#fff5e7',
  'color-system-warning-500': '#d27c05',
  'color-system-warning-900': '#623a02',
  'color-system-warning-on-inverse-100': '#ffffff',
  'color-system-warning-on-inverse-500': '#ffffff',
  'color-system-warning-on-inverse-900': '#ffffff',
  'figma-file-component-section-bg': '#f5f6f8',
  'figma-file-Section-Radius': '120px',
  'global-columns-base-desktop-full-max-width': '1680px',
  'global-columns-base-desktop-full-min-width': '360px',
  'global-columns-base-desktop-half-max-width': '828px',
  'global-columns-base-desktop-half-min-width': '320px',
  'global-columns-base-desktop-oneFourth-max-width': '480px',
  'global-columns-base-desktop-oneFourth-min-width': '224px',
  'global-columns-base-desktop-oneThird-max-width': '560px',
  'global-columns-base-desktop-oneThird-min-width': '320px',
  'global-columns-base-desktop-three-fourth-max-width': '1254px',
  'global-columns-base-desktop-three-fourth-min-width': '774px',
  'global-columns-base-mobile-full-max-width': '767px',
  'global-columns-base-mobile-full-min-width': '310px',
  'global-columns-base-mobile-half-max-width': '720px',
  'global-columns-base-mobile-half-min-width': '310px',
  'global-columns-base-mobile-oneFourth-max-width': '760px',
  'global-columns-base-mobile-oneFourth-min-width': '310px',
  'global-columns-base-mobile-oneThird-max-width': '760px',
  'global-columns-base-mobile-oneThird-min-width': '310px',
  'global-columns-base-mobile-three-fourth-max-width': '719px',
  'global-columns-base-mobile-three-fourth-min-width': '327px',
  'global-columns-base-tablet-full-max-width': '1200px',
  'global-columns-base-tablet-full-min-width': '360px',
  'global-columns-base-tablet-half-max-width': '1103px',
  'global-columns-base-tablet-half-min-width': '360px',
  'global-columns-base-tablet-oneFourth-max-width': '760px',
  'global-columns-base-tablet-oneFourth-min-width': '368px',
  'global-columns-base-tablet-oneThird-max-width': '1103px',
  'global-columns-base-tablet-oneThird-min-width': '349px',
  'global-columns-base-tablet-three-fourth-max-width': '1135px',
  'global-columns-base-tablet-three-fourth-min-width': '704px',
  'global-columns-compact-desktop-full-max-width': '1680px',
  'global-columns-compact-desktop-full-min-width': '360px',
  'global-columns-compact-desktop-half-max-width': '800px',
  'global-columns-compact-desktop-half-min-width': '560px',
  'global-columns-compact-desktop-oneFourth-max-width': '480px',
  'global-columns-compact-desktop-oneFourth-min-width': '224px',
  'global-columns-compact-desktop-oneThird-max-width': '528px',
  'global-columns-compact-desktop-oneThird-min-width': '320px',
  'global-columns-compact-mobile-full-max-width': '767px',
  'global-columns-compact-mobile-full-min-width': '316px',
  'global-columns-compact-mobile-half-max-width': '720px',
  'global-columns-compact-mobile-half-min-width': '310px',
  'global-columns-compact-mobile-oneFourth-max-width': '760px',
  'global-columns-compact-mobile-oneFourth-min-width': '310px',
  'global-columns-compact-mobile-oneThird-max-width': '760px',
  'global-columns-compact-mobile-oneThird-min-width': '310px',
  'global-columns-compact-tablet-full-max-width': '1200px',
  'global-columns-compact-tablet-full-min-width': '360px',
  'global-columns-compact-tablet-half-max-width': '1103px',
  'global-columns-compact-tablet-half-min-width': '360px',
  'global-columns-compact-tablet-oneFourth-max-width': '760px',
  'global-columns-compact-tablet-oneFourth-min-width': '368px',
  'global-columns-compact-tablet-oneThird-max-width': '1103px',
  'global-columns-compact-tablet-oneThird-min-width': '349px',
  'global-columns-wide-desktop-full-max-width': '1680px',
  'global-columns-wide-desktop-full-min-width': '360px',
  'global-columns-wide-desktop-half-max-width': '760px',
  'global-columns-wide-desktop-half-min-width': '480px',
  'global-columns-wide-desktop-oneFourth-max-width': '480px',
  'global-columns-wide-desktop-oneFourth-min-width': '224px',
  'global-columns-wide-desktop-oneThird-max-width': '560px',
  'global-columns-wide-desktop-oneThird-min-width': '320px',
  'global-columns-wide-mobile-full-max-width': '767px',
  'global-columns-wide-mobile-full-min-width': '310px',
  'global-columns-wide-mobile-half-max-width': '767px',
  'global-columns-wide-mobile-half-min-width': '310px',
  'global-columns-wide-mobile-oneFourth-max-width': '767px',
  'global-columns-wide-mobile-oneFourth-min-width': '310px',
  'global-columns-wide-mobile-oneThird-max-width': '767px',
  'global-columns-wide-mobile-oneThird-min-width': '310px',
  'global-columns-wide-tablet-full-max-width': '1200px',
  'global-columns-wide-tablet-full-min-width': '360px',
  'global-columns-wide-tablet-half-max-width': '1103px',
  'global-columns-wide-tablet-half-min-width': '360px',
  'global-columns-wide-tablet-oneFourth-max-width': '767px',
  'global-columns-wide-tablet-oneFourth-min-width': '400px',
  'global-columns-wide-tablet-oneThird-max-width': '1103px',
  'global-columns-wide-tablet-oneThird-min-width': '360px',
  'radius-radius-0': '0px',
  'radius-radius-1': '1px',
  'radius-radius-104': '104px',
  'radius-radius-12': '12px',
  'radius-radius-16': '16px',
  'radius-radius-160': '160px',
  'radius-radius-2': '2px',
  'radius-radius-24': '24px',
  'radius-radius-300': '300px',
  'radius-radius-32': '32px',
  'radius-radius-4': '4px',
  'radius-radius-40': '40px',
  'radius-radius-64': '64px',
  'radius-radius-8': '8px',
  'radius-radius-80': '80px',
  'radius-radius-rounded': '1000px',
/*  'show-kitchen-tested': 'null', */
  'spacing-spacing-0': '0px',
  'spacing-spacing-1': '1px',
  'spacing-spacing-104': '104px',
  'spacing-spacing-12': '12px',
  'spacing-spacing-120': '120px',
  'spacing-spacing-16': '16px',
  'spacing-spacing-2': '2px',
  'spacing-spacing-24': '24px',
  'spacing-spacing-32': '32px',
  'spacing-spacing-4': '4px',
  'spacing-spacing-40': '40px',
  'spacing-spacing-48': '48px',
  'spacing-spacing-56': '56px',
  'spacing-spacing-64': '64px',
  'spacing-spacing-8': '8px',
  'spacing-spacing-80': '80px',
  'spacing-spacing-96': '96px',
  'typography-font-family-agbalumo': 'var(--font-agbalumo)',
  'typography-font-family-archivo-black': 'var(--font-archivo-black)',
  'typography-font-family-baloo-chettan-2': 'var(--font-baloo-chettan-2)',
  'typography-font-family-barlow': 'var(--font-barlow)',
  'typography-font-family-besley': 'var(--font-besley)',
  'typography-font-family-bitter': 'var(--font-bitter)',
  'typography-font-family-boogaloo': 'var(--font-boogaloo)',
  'typography-font-family-caveat-brush': 'var(--font-caveat-brush)',
  'typography-font-family-delius': 'var(--font-delius)',
  'typography-font-family-Figtree': 'var(--font-figtree)',
  'typography-font-family-gabarito': 'var(--font-gabarito)',
  'typography-font-family-georgia': 'var(--font-georgia)',
  'typography-font-family-glegoo': 'var(--font-glegoo)',
  'typography-font-family-josefin-sans': 'var(--font-josefin-sans)',
  'typography-font-family-jost': 'var(--font-jost)',
  'typography-font-family-kdam-thmor-pro': 'var(--font-kdam-thmor-pro)',
  'typography-font-family-lato': 'var(--font-lato)',
  'typography-font-family-lexend': 'var(--font-lexend)',
  'typography-font-family-lora': 'var(--font-lora)',
  'typography-font-family-montserrat': 'var(--font-montserrat)',
  'typography-font-family-mouse-memoirs': 'var(--font-mouse-memoirs)',
  'typography-font-family-noto-sans': 'var(--font-noto-sans)',
  'typography-font-family-noto-serif': 'var(--font-noto-serif)',
  'typography-font-family-nunito-sans': 'var(--font-nunito-sans)',
  'typography-font-family-oswald': 'var(--font-oswald)',
  'typography-font-family-pangolin': 'var(--font-pangolin)',
  'typography-font-family-patrick-hand': 'var(--font-patrick-hand)',
  'typography-font-family-paytone-one': 'var(--font-paytone-one)',
  'typography-font-family-poppins': 'var(--font-poppins)',
  'typography-font-family-red-rose': 'var(--font-red-rose)',
  'typography-font-family-relaxe': 'var(--font-relaxe)',
  'typography-font-family-Righteous': 'var(--font-righteous)',
  'typography-font-family-roboto': 'var(--font-roboto)',
  'typography-font-family-roboto-slab': 'var(--font-roboto-slab)',
  'typography-font-family-rubik': 'var(--font-rubik)',
  'typography-font-family-slackey': 'var(--font-slackey)',
  'typography-font-family-sniglet': 'var(--font-sniglet)',
  'typography-font-family-snippity-snap': 'var(--font-dk-snippity-snap)',
  'typography-font-family-source-code-pro': 'var(--font-source-code-pro)',
  'typography-font-family-yellowtail': 'var(--font-yellowtail)',
  'typography-font-family-zilla-slab': 'var(--font-zilla-slab)',
  'typography-font-size-font-size-10': '0.625rem',
  'typography-font-size-font-size-104': '6.5rem',
  'typography-font-size-font-size-12': '0.75rem',
  'typography-font-size-font-size-120': '7.5rem',
  'typography-font-size-font-size-14': '0.875rem',
  'typography-font-size-font-size-16': '1rem',
  'typography-font-size-font-size-18': '1.125rem',
  'typography-font-size-font-size-20': '1.25rem',
  'typography-font-size-font-size-24': '1.5rem',
  'typography-font-size-font-size-28': '1.75rem',
  'typography-font-size-font-size-32': '2rem',
  'typography-font-size-font-size-36': '2.25rem',
  'typography-font-size-font-size-40': '2.5rem',
  'typography-font-size-font-size-48': '3rem',
  'typography-font-size-font-size-56': '3.5rem',
  'typography-font-size-font-size-64': '4rem',
  'typography-font-size-font-size-72': '4.5rem',
  'typography-font-size-font-size-80': '5rem',
  'typography-font-size-font-size-88': '5.5rem',
  'typography-font-size-font-size-96': '6rem',
};
